import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_TRADING_ENGINE + "OrderReleaseLimit/";
const delegatedEndpoint = apiEndpoint + "Delegated/";

export async function getOrganizationOrderReleaseLimits(organizationId) {
  const { data } = await http.get(apiEndpoint + "Organization/" + organizationId);
  return data;
}

export async function saveOrganizationOrderReleaseLimits(organizationId, limits) {
  const { data } = await http.put(
    apiEndpoint + "Organization/" + organizationId + "/Bulk",
    limits,
  );
  return data;
}

export async function getDelegatedOrganizationOrderReleaseLimits(organizationId) {
  const { data } = await http.get(
    delegatedEndpoint + "Organization/" + organizationId,
  );
  return data;
}

export async function saveDelegatedOrganizationOrderReleaseLimits(
  organizationId,
  limits,
) {
  const { data } = await http.put(
    delegatedEndpoint + "Organization/" + organizationId + "/Bulk",
    limits,
  );
  return data;
}

export async function getUserAccountOrderReleaseLimits(
  organizationId,
  userAccountId,
) {
  const { data } = await http.get(
    apiEndpoint + "UserAccount/" + organizationId + "/" + userAccountId,
  );
  return data;
}

export async function saveUserAccountOrderReleaseLimits(
  organizationId,
  userAccountId,
  limits,
) {
  const { data } = await http.put(
    apiEndpoint +
      "UserAccount/" +
      organizationId +
      "/" +
      userAccountId +
      "/Bulk",
    limits,
  );
  return data;
}

export async function getDelegatedUserAccountOrderReleaseLimits(
  organizationId,
  userAccountId,
) {
  const { data } = await http.get(
    delegatedEndpoint +
      "UserAccount/" +
      organizationId +
      "/" +
      userAccountId,
  );
  return data;
}

export async function saveDelegatedUserAccountOrderReleaseLimits(
  organizationId,
  userAccountId,
  limits,
) {
  const { data } = await http.put(
    delegatedEndpoint +
      "UserAccount/" +
      organizationId +
      "/" +
      userAccountId +
      "/Bulk",
    limits,
  );
  return data;
}

export async function getCurrentOrderReleaseLimits(organizationId) {
  const { data } = await http.get(apiEndpoint + "Current/" + organizationId);
  return data;
}
